import { render, staticRenderFns } from "./SeleccioneDocumento.vue?vue&type=template&id=12e68263&scoped=true&"
import script from "./SeleccioneDocumento.vue?vue&type=script&lang=js&"
export * from "./SeleccioneDocumento.vue?vue&type=script&lang=js&"
import style0 from "./SeleccioneDocumento.vue?vue&type=style&index=0&id=12e68263&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e68263",
  null
  
)

export default component.exports